enum PhdApiEndpoints {
    STORE_SEARCH = '/stores/search',
    GET_STORE = '/stores/%s'
}

export default PhdApiEndpoints;
